// extracted by mini-css-extract-plugin
export var chatHtmlText = "_u9-2";
export var chatLink = "_u9-0";
export var chatText = "_u9-1";